import React from 'react';
import { Box } from '@mui/material';

/** Centered content column. Default max-width 1400 (prototype max-w-[1400px]). */
export default function ScreenContainer({ children, maxWidth = 1400, sx = {} }) {
  return (
    <Box sx={{ maxWidth, mx: 'auto', width: '100%', ...sx }}>
      {children}
    </Box>
  );
}
